import "../../styles/components/_breadcrumbs.scss";
import { waitForElements } from "../helpers/utils";
import { csqTrackDynamicVariable, csqTrackPageEvent, emitShopifyEvent } from "../services/analytics.service";
console.log("product template loaded");
// Fabric module segmentation — only fires when the section renders (i.e. product has a fabric metafield).
// The fabric name is read from the DOM rather than the dataLayer to avoid jQuery timing dependencies.
// @see product-primary-fabric.liquid, analytics.service.ts
const fabricContainer = document.querySelector('.product-primary-fabric__container');
if (fabricContainer) {
    const fabricName = fabricContainer.dataset.fabricName;
    csqTrackPageEvent('fabric_module_present');
    if (fabricName) {
        csqTrackDynamicVariable('primary_fabric', fabricName);
    }
}
// Product department segmentation (e.g. "Mens", "Womens").
// window.productDepartment is set synchronously by product-main.liquid before any module code runs,
// so it is reliably available here without a timing guard.
if (window.productDepartment) {
    csqTrackDynamicVariable('product_department', window.productDepartment);
}
if (window.productCompareAtPrice !== undefined) {
    csqTrackDynamicVariable('product_is_markdown', window.productCompareAtPrice > 0 ? 'yes' : 'no');
}
const productType = window.segmentLayer?.product?.category;
if (productType) {
    csqTrackDynamicVariable('product_type', productType);
}
waitForElements('.product__review-container > [data-bv-ready="true"]').then((els) => {
    console.log("product reviews loaded and visible");
    const loadedReviewsContainer = els[0];
    const observer = new IntersectionObserver((entries, observer) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
            emitShopifyEvent("untuckit:product_reviews_viewed");
            observer.disconnect();
        }
    }, {
        threshold: [0.3]
    });
    observer.observe(loadedReviewsContainer);
});
